/*eslint no-extend-native: "off"*/

export { };

declare global {
    interface Date {
        convertLocalToUtcDate(): Date;
        convertUtcToLocalDate(): Date;
        applyOffset(offset: number): Date;
        convertFromTimezoneToUtc(timeZone: string): Date;
        convertFromUtcToTimezone(timeZone: string): Date;
        getTimezoneUtcOffset(timeZone: string): number;
        getTimezoneUtcOffsetInMinutes(timeZone: string): number;
        getTimezoneOffsetName(timeZone: string): string;
        isInitialOrEndTime(): boolean;
        putStartOfDay(): Date;
        putEndOfDay(): Date;
    }

    interface String {
        toCamelcase(): string;
    }
}

declare module "notistack" {
    interface VariantOverrides {
        mprcAction: true;
    }
}

//#region Date

(function () {
    Date.prototype.convertLocalToUtcDate = function (): Date {
        var d = this;
        return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
    };

    Date.prototype.convertUtcToLocalDate = function (): Date {
        var d = this;
        return new Date(d.getTime() - (new Date()).getTimezoneOffset() * 60000);
    };

    Date.prototype.applyOffset = function (offsetMinutes: number): Date {
        var d = this;
        var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        return new Date(utc + (60000 * offsetMinutes));
    };

    Date.prototype.putStartOfDay = function (): Date {
        if (this === null) return this;
        var d = this;
        var nd = new Date(d);
        nd.setHours(0);
        nd.setMinutes(0);
        nd.setSeconds(0);
        return nd;
    };
    Date.prototype.putEndOfDay = function (): Date {
        if (this === null) return this;
        var d = this;
        var nd = new Date(d);
        nd.setHours(23);
        nd.setMinutes(59);
        nd.setSeconds(59);
        return nd;
    };

    Date.prototype.getTimezoneUtcOffset = function (timeZone: string): number {
        var date = this;
        const tz = date.toLocaleString("en", { timeZone, timeStyle: "long" }).split(" ").slice(-1)[0];
        const dateString = date.toString();
        const offset = Date.parse(`${dateString} UTC`) - Date.parse(`${dateString} ${tz}`);
        return offset;
    };

    Date.prototype.getTimezoneUtcOffsetInMinutes = function (timeZone: string): number {
        return this.getTimezoneUtcOffset(timeZone) / 60000;
    };

    Date.prototype.convertFromTimezoneToUtc = function (timeZone: string): Date {
        if (Intl.DateTimeFormat().resolvedOptions().timeZone == timeZone) return this;
        return new Date(this.getTime() - this.getTimezoneUtcOffset(timeZone) + this.getTimezoneUtcOffset(Intl.DateTimeFormat().resolvedOptions().timeZone));
    };

    Date.prototype.convertFromUtcToTimezone = function (timeZone: string): Date {
        if (Intl.DateTimeFormat().resolvedOptions().timeZone == timeZone) return this;
        return new Date(this.getTime() + this.getTimezoneUtcOffset(timeZone) - this.getTimezoneUtcOffset(Intl.DateTimeFormat().resolvedOptions().timeZone));
    };

    Date.prototype.isInitialOrEndTime = function (): boolean {
        return (this.getHours() === 0 && this.getMinutes() === 0 && this.getSeconds() === 0) ||
            (this.getHours() === 23 && this.getMinutes() === 59 && this.getSeconds() === 59);
    };

    Date.prototype.getTimezoneOffsetName = function (timezone: string): string {
        const parts = this.toLocaleString('pt-BR', { timeZone: timezone, timeZoneName: 'longOffset' }).split(' ');
        if (parts.length == 3) return parts[2];
        return "";
    };

    //#endregion

    //#region String

    String.prototype.toCamelcase = function (): string {
        return this.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) { return index == 0 ? word.toLowerCase() : word.toUpperCase(); }).replace(/\s+/g, '');
    };

    //#endregion
})();